export enum EExerciseJumpType {
    VERTICAL,
    DROP_JUMP
}
